import { ReactNode } from "react";
import { AlertCircle } from "lucide-react";

interface ErrorDisplayProps {
  title?: string;
  message: string;
  action?: ReactNode;
}

const ErrorDisplay = ({ title = "Error", message, action }: ErrorDisplayProps) => {
  return (
    <div className="container mx-auto py-12 px-4">
      <div className="max-w-md mx-auto bg-red-50 border border-red-200 rounded-lg p-6 text-center">
        <AlertCircle className="h-12 w-12 mx-auto text-red-500 mb-4" />
        <h2 className="text-xl font-semibold text-red-700 mb-2">{title}</h2>
        <p className="text-gray-700 mb-6">{message}</p>
        {action && <div>{action}</div>}
      </div>
    </div>
  );
};

export default ErrorDisplay; 